import isReactNative from './isReactNative';

/**
 * @ignore
 */
export default function importReactNativeWebView(): Promise<any> {
    if (!isReactNative) {
        return Promise.reject(new Error('React Native environment not detected.'));
    }
    // TODO @compel Umíme udělat lépe?
    // Zcela záměrně importujeme takto a ne jako import('react-native-webview').
    // Jde o hack, aby parcel i webpack držely hubu a nesnažily se načíst
    // chybějící volitelnou react-native-webview závislosti.
    return import('react-native-webview'.toLowerCase());
}
